import { handleApiResponse, notify } from '@/functions';
import { useMutation } from '@tanstack/react-query';
import { useInvalidateQueries } from '@/hooks';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';
import type { IPaymentProvider } from '@/interfaces/paymentProvider.interface';

type TVariables = Omit<IPaymentProvider, 'provider'> & { provider: string };

export const useRequestCreatePaymentOperator = () => {

  const { invalidate } = useInvalidateQueries();
  const { isPending, error, mutateAsync } = useMutation({
    mutationKey: [routes.api.createPaymentOperator, 'create'],
    mutationFn: (dto: TVariables) =>
      apiClient
        .post<void>(routes.api.createPaymentOperator, dto)
        .then(handleApiResponse)
        .catch(error => {
          notify(error?.internalMessage, 'error');
          throw error;
        }),
    onSuccess: () => {
      invalidate(routes.api.paymentProviders);
      notify('Opérateur créé avec succès', 'success');
    }
  });

  return ({
    isLoadingCreatePaymentOperator: isPending,
    triggerCreatePaymentOperator: (dto: TVariables) => mutateAsync(dto),
    error
  });

};
